module.exports = __webpack_public_path__ + "media/images/real-ilum-1-cc027d326cb51651bfaea166cd5e0cea.png";